// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"index_icon-wrapper__qSuQ0"};